import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'
import arrowDown from 'assets/shop/arrowDown.png'

function FilterOptions({ title, options, selectedFilter, onFilterChange }) {
  const [isOpen, setIsOpen] = useState(false)
  const closeRef = useRef(null)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleFilterChange = (option) => {
    onFilterChange(option)
    setIsOpen(false)
  }

  const handleClickOutside = (event) => {
    if (closeRef.current && !closeRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  return (
    <div className={`filter-catalog  ${title === 'Filter prices' ? 'selected-name-filter' : ''}`}>
      <div className="custom-select">
        <div className="select-box" onClick={toggleDropdown}>
          <p className={`seleted ${title === 'Color' ? 'color-row' : ''}`}>{title}</p>

          <img src={arrowDown} alt="arrow" />
        </div>
        {isOpen && (
          <div
            className={`select-dropdown ${title === 'Color' ? 'select-dropdown-color' : ''}`}
            ref={closeRef}
          >
            <div className="frame-option">
              {options.map((option) => (
                <div
                  key={option.display}
                  className={`select-option`}
                  onClick={() => handleFilterChange(option)}
                >
                  <input
                    type="radio"
                    name={title}
                    value={option.display}
                    checked={selectedFilter === option}
                    readOnly
                  />
                  <p>{option.display}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

FilterOptions.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  selectedFilter: PropTypes.object,
  onFilterChange: PropTypes.func
}

export default FilterOptions
